export default (theme) => ({
  main: {
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: 0.7,
  },
  second: {
    fontSize: 18,
    fontWeight: '200',
  },
});
